import {
  getClassroomDetails,
  listSnapshots,
  createBackup,
  listClassrooms,
  exportSnapshot,
  restoreSnapshot
} from "@/services/api/google/recovery/classroom/classroom";
import {defaultPagination} from "@/services/pagination";
import announcement from "@/store/app/google/recovery/classroom/data-set/announcement";
import classwork from "@/store/app/google/recovery/classroom/data-set/classwork";
import classworkDrive from "@/store/app/google/recovery/classroom/data-set/drive";
import grade from "@/store/app/google/recovery/classroom/data-set/grade";
import people from "@/store/app/google/recovery/classroom/data-set/people";
import wholeClass from "@/store/app/google/recovery/classroom/data-set/wholeClass";
import exports from "@/store/app/google/recovery/classroom/exports";
import restores from "@/store/app/google/recovery/classroom/restores";
import backups from "@/store/app/google/recovery/classroom/backups";
import user from "@/store/app/google/recovery/classroom/user";

const defaultState = () => ({
  classrooms: [],
  classroomMap: {},
  pagination: {
    ...defaultPagination(),
    sortBy: 'name',
    sortDescending: false
  },
  search: null
});

export default {
  namespaced: true,
  actions: {
    listClassrooms({commit, state},) {
      return listClassrooms({
        pagination: state.pagination,
        search: state.search,
        filter: {
          "statuses": [
            1, 2, 4
          ]
        }
      })
        .then(({result, pagination}) => {
          commit('setClassrooms', result)
          commit('setPagination', pagination)
        })
    },
    getClassroomDetails({commit}, classroomId) {
      return getClassroomDetails(classroomId)
        .then(classroom => {
          commit('setClassroom', classroom);
          return classroom;
        })
    },
    createBackup({commit}, classroomId) {
      return createBackup(classroomId);
    },
    listSnapshots({commit}, {classroomId, date, dateTo}) {
      return listSnapshots({classroomId, date, dateTo});
    },
    exportSnapshot({commit}, data) {
      return exportSnapshot(data);
    },
    restoreSnapshot({}, data) {
      return restoreSnapshot(data);
    },
  },

  mutations: {
    setClassrooms(state, classrooms) {
      state.classrooms = classrooms;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state, {keepSort}) {
      if (keepSort) {
        state.pagination = {
          ...defaultPagination(),
          sortBy: state.pagination.sortBy,
          sortDescending: state.pagination.sortDescending,
        }
      } else {
        state.pagination = {
          ...defaultPagination(),
          sortBy: 'name',
          sortDescending: false
        };
      }

    },
    setSearchFiles(state, search) {
      state.search = search;
    },
    setClassroom(state, classroom) {
      state.classroomMap = {
        ...state.classroomMap,
        [classroom.classroomId]: classroom
      };
    },
    resetState(state) {
      Object.assign(state, defaultState())
    }
  },

  getters: {
    getClassroomById: (state) => (id) => {
      return state.classroomMap[id];
    },
  },

  state: defaultState(),

  modules: {
    announcement,
    classwork,
    drive: classworkDrive,
    grade,
    people,
    wholeClass,
    exports,
    restores,
    backups,
    user
  },
}
